import { createRoute } from '@tanstack/react-router';

import { StaffPage } from '@/components/admin/StaffPage';
import { TelemetryPanel } from '@/components/admin/TelemetryPanel';
import { seoHead } from '@/lib/seo/routeMeta';

import { Route as rootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/telemetry',
  head: () => seoHead('/telemetry'),
  component: TelemetryPage,
});

function TelemetryPage() {
  return (
    <StaffPage>
      <TelemetryPanel />
    </StaffPage>
  );
}
